import logError from 'src/data/services/logError';
import React from 'react';
import { View, ScrollView, StyleSheet, Text, Image, TouchableOpacity, Share } from 'react-native';
import { useRoute } from '@react-navigation/native';
import type { RouteProp } from '@react-navigation/native';
import NavBar from 'src/presentation/components/organisms/NavBar';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import type { RootStackParamList } from 'src/presentation/navigation/types/NavigationTypes';
import Fonts from 'src/core/utils/Fonts';
import type Constants from 'src/core/utils/Constants';

function NewsItemScreen() {
	const route = useRoute<RouteProp<RootStackParamList, typeof Constants.screenNewsItem>>();
	const params = route?.params as Record<string, unknown>;
	const data = params?.data as {
		intro: string;
		url: string;
		title: string;
		image: { url: string };
		date: string;
		content: string;
	};

	const shareNewsItem = () => {
		Share.share(
			{
				message: `${data.intro} Lees hier het gehele nieuwsbericht: ${data.url}`,
				title: data.title,
			},
			{
				dialogTitle: data.title,
			},
		).catch(logError);
	};

	if (!data) return null;

	return (
		<View style={styles.layoutContainer}>
			<NavBar
				backBtn={true}
				bgcolor={Colors.primary}
				centerTitle={true}
				color={Colors.black}
				editBtn={false}
				title="Topicus Nieuws"
			/>
			<ScrollView>
				<View style={styles.container}>
					{data.image?.url ? <Image resizeMode="cover" source={{ uri: data.image.url }} style={styles.img} /> : null}
					<Text style={styles.published}>Gepubliceerd op: {data.date}</Text>
					<Text style={styles.title}>{data.title}</Text>
					<View style={styles.underLine} />
					<Text style={styles.intro}>{data.intro}</Text>
					<Text style={styles.content}>{data.content}</Text>
					<View style={styles.button}>
						<TouchableOpacity style={styles.cta} onPress={shareNewsItem}>
							<Text style={styles.label}>NIEUWS DELEN</Text>
						</TouchableOpacity>
					</View>
				</View>
			</ScrollView>
		</View>
	);
}

export default NewsItemScreen;

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		backgroundColor: Colors.white,
		paddingBottom: Dimens.padding30,
	},
	layoutContainer: {
		flex: 1,
	},
	img: {
		height: 210,
		width: '100%',
	},
	published: {
		fontSize: Dimens.fontSize13,
		fontFamily: Fonts.montserratLightItalic,
		color: Colors.greyText,
		marginTop: Dimens.margin10,
		marginBottom: Dimens.margin20,
		paddingLeft: Dimens.padding20,
		paddingRight: Dimens.padding20,
	},
	title: {
		fontSize: Dimens.fontSize20,
		color: Colors.greyTextDark,
		fontFamily: Fonts.montserratBold,
		paddingLeft: Dimens.padding20,
		paddingRight: Dimens.padding20,
		width: '100%',
	},
	underLine: {
		backgroundColor: Colors.yellowSecondary,
		width: 20,
		height: 2,
		marginTop: 9,
		marginBottom: 9,
		marginLeft: Dimens.margin20,
		marginRight: Dimens.margin20,
	},
	intro: {
		fontSize: Dimens.fontSize17,
		color: Colors.greyTextDark,
		fontFamily: Fonts.montserratMedium,
		marginBottom: Dimens.margin12,
		paddingLeft: Dimens.padding20,
		paddingRight: Dimens.padding20,
		width: '100%',
	},
	content: {
		fontSize: Dimens.fontSize17,
		color: Colors.greyTextDark,
		fontFamily: Fonts.montserratRegular,
		paddingLeft: Dimens.padding20,
		paddingRight: Dimens.padding20,
		lineHeight: Dimens.lineHeight23,
	},
	label: {
		fontFamily: Fonts.montserratRegular,
		color: Colors.white,
	},
	cta: {
		paddingTop: 17,
		paddingBottom: 17,
		paddingLeft: Dimens.padding25,
		paddingRight: Dimens.padding25,
		marginTop: Dimens.margin24,
		backgroundColor: Colors.secondary,
	},
	button: {
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
	},
});
